import React, { useEffect, useState } from "react";
import "../browse/MovieDetail.css";
import YouTube from "react-youtube";
export default function MovieDetailSearch({ movieDataSearch }) {
  const [trailerKey, setTrailerKey] = useState("");

  const apiKey = "5b0190c1a35e1e2882bf044c97ee37a8";

  const opts = {
    height: "400",
    width: "100%",
    playerVars: {
      autoplay: 0,
    },
  };

  useEffect(() => {
    const fetchTrailer = async () => {
      const response = await fetch(
        `https://api.themoviedb.org/3/movie/${movieDataSearch.id}/videos?api_key=${apiKey}`
      );
      const data = await response.json();
      const trailer = data.results.find(
        (video) =>
          video.site === "YouTube" &&
          (video.type === "Trailer" || video.type === "Teaser")
      );
      setTrailerKey(trailer ? trailer.key : "");
    };
    if (movieDataSearch) fetchTrailer();

    console.log(movieDataSearch);
  }, [movieDataSearch]);
  return (
    <div className="movie-detail">
      {movieDataSearch && (
        <>
          <div className="movie-detail-data">
            <h1>{movieDataSearch.title}</h1>
            <hr />
            <h3>Release Date: {movieDataSearch.release_date}</h3>
            <h3>Vote: {movieDataSearch.vote_average}/10</h3>
            <p>{movieDataSearch.overview}</p>
          </div>

          <div className="movie-detail-trailer">
            {trailerKey ? (
              <YouTube videoId={trailerKey} opts={opts} />
            ) : (
              movieDataSearch.backdrop_path && ( // Chỉ hiển thị hình ảnh nếu backdrop_path có giá trị
                <img
                  src={`https://image.tmdb.org/t/p/original${movieDataSearch.backdrop_path}`}
                  alt={movieDataSearch.title}
                  style={{ width: "100%", height: "auto" }}
                />
              )
            )}
          </div>
        </>
      )}
    </div>
  );
}
